module.exports = __webpack_public_path__ + "img/solar.f951e7be.png";